import { LogoutDialogState } from './logout-dialog.state';

/**
 * Initialer State für den Logout-Dialog.
 */
export const logoutDialogStateInitial: LogoutDialogState = {
  isOpen: false,
};
